module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av61-611196eb7efe8b376e326c9c27a20567.jpg";